// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1MnsZ","textarea":"styles_textarea__bS-cr"};